<div class="snackBarMainDiv d-flex justify-content-between align-items-center">
    <div *ngIf="!data.icon" class="message cursorPointer">
        <span [textContent]="data.message"></span>
        <span class="actionText" (click)="snackBarRef.dismissWithAction()" [textContent]="data.action"></span>
    </div>
    <div *ngIf="data.icon" class="message cursorPointer">
        <mat-icon class="snackbarIcon" [textContent]="data.icon"></mat-icon> <strong [textContent]="data.iconText"></strong>
        <span [textContent]="data.message"></span>
        <span class="actionText" (click)="snackBarRef.dismissWithAction()" [textContent]="data.action"></span>
    </div>
    <mat-icon title="Close" class="material-icons-filled cancelIcon snackCloseBtnIcon position-relative" (click)="snackBarRef.dismiss()">
        close</mat-icon>
</div>
